"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResizeDetectDivInternal = void 0;
/* eslint-disable @typescript-eslint/no-unused-vars */
var React = __importStar(require("react"));
var react_resize_detector_1 = require("react-resize-detector");
var ResizeDetectDivInternal = /** @class */ (function (_super) {
    __extends(ResizeDetectDivInternal, _super);
    function ResizeDetectDivInternal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ResizeDetectDivInternal.prototype.componentDidUpdate = function (prevProps) {
        var _a = this.props, width = _a.width, height = _a.height;
        var widthChanged = width - prevProps.width;
        var heightChanged = height - prevProps.height;
        if (widthChanged && this.props.onWidthChange) {
            this.props.onWidthChange(width);
        }
        if (heightChanged && this.props.onHeightChange) {
            this.props.onHeightChange(height);
        }
        if ((heightChanged || widthChanged) && this.props.onResize) {
            this.props.onResize(width, height);
        }
    };
    ResizeDetectDivInternal.prototype.render = function () {
        var _a = this.props, width = _a.width, height = _a.height, children = _a.children, onResize = _a.onResize, onWidthChange = _a.onWidthChange, onHeightChange = _a.onHeightChange, targetRef = _a.targetRef, rest = __rest(_a, ["width", "height", "children", "onResize", "onWidthChange", "onHeightChange", "targetRef"]);
        return React.createElement("div", __assign({}, rest), children);
    };
    return ResizeDetectDivInternal;
}(React.Component));
exports.ResizeDetectDivInternal = ResizeDetectDivInternal;
exports.default = react_resize_detector_1.withResizeDetector(ResizeDetectDivInternal);
